import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthProvider = ({ children }) => {
  let location = useLocation();
  const auth = useSelector((state) => state.authReducer.isAuthenticated);

  if (!auth) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthProvider;
